import { Component, Shark } from "shark-mvc";

import templateContent from "./status-smart-filter.html";

class StatusSmartFilterComponent extends Component {
	constructor () {
		super("statusSmartFilterComponent");
		this.addTemplate("", templateContent);
	}

	init () {
	}

	getActiveStatuses () {
		return Shark.get("statusSmartFilterFilters").filters.filter(item => item.active).map(item => item.status).flat();
	}

	setFilters (filters) {
		const smartFilters = Shark.getInstance("__smart__", {
			filters,
			__triggerer: false,
		});

		smartFilters.on("dataChanged", function (event, data) {
			console.log(data);

			if (data.property.slice(0, 8) === "activate") {
				this.filters.find(item => item.statusName === data.property.slice(8)).active = data.newValue;
				delete this[data.property];
			}

			if (Shark.activePage.saveFiltersStatus) {
				Shark.activePage.saveFiltersStatus(this);
			}

			console.log(this, data);
			
			if (this.filters.filter(item => item.active).length > 0) {
				if (Shark.activePage.refreshList) {
					Shark.activePage.refreshList();
				}
			}
			else {
				Shark.set({
					sampleRequestList: [],
					__sampleRequestListNeedFurtherLoad: false,
				});
		
				Shark.render();
			}
		});
		Shark.set({
			statusSmartFilterFilters: smartFilters,
		});
	}

	activateSingleFilterBtn_clickHandler (event, data) {
		const commaPresent = data.status.includes(",");
		const clickedStatus = commaPresent ? data.status.split(",") : [parseInt(data.status)];
		const { statusSmartFilterFilters } = Shark.get();

		if (data.status === "all") {
			statusSmartFilterFilters.filters.forEach(item => item.active = true);
		}
		else {
			statusSmartFilterFilters.filters.forEach(item => item.active = item.status.toString() === clickedStatus.toString() || [item.status].toString() === clickedStatus.toString());
		}

		statusSmartFilterFilters.set({
			__triggerer: !statusSmartFilterFilters.__triggerer,
		});
	}

}

const statusSmartFilterComponent = new StatusSmartFilterComponent();

Shark.registerComponent(statusSmartFilterComponent);

export default statusSmartFilterComponent;
